import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthProvider } from './contexts/AuthContext';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { TooltipProvider } from './components/ui/tooltip';
import { ConfirmHost } from './components/common/confirm';
import ValidationHost from './components/common/ValidationHost';
import TipLayer from './components/common/TipLayer';

// One light theme only (Harbor). Clear any old dark-mode choice.
document.documentElement.setAttribute('data-theme', 'light');
try { localStorage.removeItem('fd-theme'); } catch (e) { /* storage unavailable */ }

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <BrowserRouter>
            <AuthProvider>
                <TooltipProvider delayDuration={250} skipDelayDuration={150}>
                    <App />
                    <ConfirmHost />
                </TooltipProvider>
                <ValidationHost />
                <TipLayer />
                <ToastContainer
                    position="top-right"
                    autoClose={3000}
                    hideProgressBar={false}
                    newestOnTop
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="light"
                />
            </AuthProvider>
        </BrowserRouter>
    </React.StrictMode>
);
